import useAuthentication from "../Service/hooks/useAuthentication";
import usePasskey from "../Service/hooks/usePasskey";

export default function PasskeyForm({ onOtherLogin }) {

    const { tokens } = useAuthentication();
    const { startPasskeyLogin } = usePasskey();
    const passkeyToken = tokens?.find(token => token.t === 'passkey');


    return <div className="flex flex-col gap-3">
        <button className="p-2 border border-gray-400 rounded-xl w-full" onClick={() => startPasskeyLogin(passkeyToken)}>
            <span className="text-gray-500">Ga verder als: </span> {passkeyToken.email}

        </button>
        <hr />
        <button className="p-2 border border-gray-400 rounded-xl w-full" onClick={() => onOtherLogin(() => true)}>
            Login met een ander account
        </button>
    </div>




}